import React from 'react';

const ServiceFaqTab = ({ serviceForm, addFaqItem, updateFaqItem, removeFaqItem }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h4 className="font-medium">FAQ (RU)</h4>
      <button
        type="button"
        onClick={() => addFaqItem('ru')}
        className="text-sm text-orange-600 hover:text-orange-700"
        data-testid="add-faq-ru-btn"
      >
        + Добавить вопрос
      </button>
    </div>
    {serviceForm.faq_ru.map((faq, idx) => (
      <div key={idx} className="bg-gray-50 p-3 rounded-lg space-y-2">
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Вопрос {idx + 1}</span>
          <button
            type="button"
            onClick={() => removeFaqItem('ru', idx)}
            className="text-red-500 text-sm"
            data-testid={`remove-faq-ru-${idx}`}
          >
            Удалить
          </button>
        </div>
        <input
          type="text"
          value={faq.question}
          onChange={(e) => updateFaqItem('ru', idx, 'question', e.target.value)}
          placeholder="Вопрос"
          className="w-full px-3 py-2 border rounded-lg text-sm"
        />
        <textarea
          value={faq.answer}
          onChange={(e) => updateFaqItem('ru', idx, 'answer', e.target.value)}
          placeholder="Ответ"
          rows={2}
          className="w-full px-3 py-2 border rounded-lg text-sm"
        />
      </div>
    ))}
    {serviceForm.faq_ru.length === 0 && (
      <p className="text-gray-500 text-sm text-center py-4">Нет вопросов. Нажмите "Добавить вопрос"</p>
    )}
  </div>
);

export default ServiceFaqTab;
